import React, { use, useEffect } from "react";
import { Avatar, Dropdown, Menu } from "antd";
import {
  UserOutlined,
  SettingOutlined,
  LogoutOutlined,
  LockOutlined,
  EditOutlined,
  HeartOutlined,
  MessageOutlined,
  FolderOpenOutlined,
  UserAddOutlined,
} from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../user/context/AuthContext";
import { image_base_url } from "../../constants/Constant";
import useGetApi from "../../services/useGetApi";
import { images } from "../../assests/imageExport/ImageExports";

const ProfileMenu = () => {
  const navigate = useNavigate();
  const { confirmLogout, token } = useAuth();
  const [currentUser, setCurrentUser] = React.useState(null);
  const [isLoading, error, userData, getData] = useGetApi(
    `users/get`,
    [],
    true
  );

  useEffect(() => {
    getData(`users/get`);
  }, []);

  const handleMenuClick = ({ key }) => {
    if (key === "logout") {
      confirmLogout();
    } else if (key === "edit-profile") {
      navigate("/edit-profile");
    } else if (key === "change-password") {
      navigate("/change-password");
    } else if (key === "settings") {
      navigate("/settings");
    } else if (key === "instructor-dashboard") {
      navigate("/instructor/dashboard");
    } else if (key === "my-courses") {
      navigate("/user/my-courses");
    } else if (key === "my-wishlist") {
      navigate("/user/my-wishlist");
    } else if (key === "my-message") {
      navigate("/user/messages");
    } else if (key === "my-profile") {
      navigate("/user/user-profile");
    } else if (key === "my-account") {
      navigate("/user/account");
    }
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    setCurrentUser(user);
  }, []);

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item
        key="profile-avatar"
        disabled
        style={{ padding: "10px 0", textAlign: "center" }}
      >
        <Avatar src={`${image_base_url}${userData?.image}`} size={64} />
        <h3>{userData?.firstName}</h3>
      </Menu.Item>

      {userData && userData.roles && userData.roles.length > 0 && userData.roles[0].name === "ROLE_INSTRUCTOR" && (
        <Menu.Item key="instructor-dashboard" icon={<UserOutlined />}>
          Instructor Dashboard
        </Menu.Item>
      )}

      {/* <Link to={"/instructor/dashboard"} className="link">
        <p className="navbar_user_info_details">
          <UserOutlined /> Instructor Dashboard
        </p>
      </Link> */}
      {/* <Link to={'/user/dashboard'} className='link'>
         <p className="navbar_user_info_details"><UserOutlined /> Instructor Dashboard</p>
      </Link> */}
      {/* <Menu.Item key="edit-profile" icon={<EditOutlined />}>
        Edit Profile
      </Menu.Item>
      <Menu.Item key="change-password" icon={<LockOutlined />}>
        Change Password
      </Menu.Item>
      <Menu.Item key="settings" icon={<SettingOutlined />}>
        Settings
      </Menu.Item> */}
      <Menu.Item key="my-courses" icon={<FolderOpenOutlined />}>
        My courses
      </Menu.Item>
      <Menu.Item key="my-wishlist" icon={<HeartOutlined />}>
        My wishlist
      </Menu.Item>
      <Menu.Item key="my-message" icon={<MessageOutlined />}>
        My messages
      </Menu.Item>
      <Menu.Item key="my-profile" icon={<UserOutlined />}>
        My profile
      </Menu.Item>
      <Menu.Item key="my-account" icon={<UserAddOutlined />}>
        Account
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="logout" icon={<LogoutOutlined />} danger>
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
      {/* <Avatar size={40} icon={<UserOutlined />} style={{ cursor: "pointer" }} /> */}
      <img 
        src={
          userData?.image 
            ? `${image_base_url}${userData?.image}`
            : images.broken_instructor_jpg
        }
        alt="User"
        className="user-icon"
      />
    </Dropdown>
  );
};
 
export default ProfileMenu;
